import styled from "styled-components";

export const AiAssistantWrapper = styled.div`
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    width: 100%;
    height: 100%;
    border-radius: 5px;
    background-color: transparent;
    position: relative;
    overflow: hidden;

    & .ant-drawer-header {
        padding: 10px;
    }
    & .ant-drawer-body {
        padding: 0px;
    }
`;

export const HeaderWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    flex-shrink: 0;
    padding: 12px 20px;
`;

export const HeaderTitle = styled.h2`
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    color: #3333333;
`;

export const ChatAreaWrapper = styled.div`
    flex: 1 1 auto;
    overflow-y: auto;
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const MessageWrapper = styled.div<{ isUser: boolean }>`
    display: flex;
    justify-content: ${props => props.isUser ? 'flex-end' : 'flex-start'};
`;

export const MessageBubble = styled.div<{ isUser: boolean }>`
    width: ${props => props.isUser ? 'auto' : '100%'}; 
    padding: 10px;
    border-radius: 22px;
    font-size: 14px;
    line-height: 1.6;
    word-break: break-word;
    background: ${props => props.isUser ? '#F0F0F0' : 'transparent'};
    color: ${props => props.isUser ? '#FFFFFF' : '#333333'};
`;

export const MessageContent = styled.div`
    width: 100%;
`;

export const MessageLoading = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    
    span {
        width: 6px;
        height: 6px;
        background: #1890ff;
        border-radius: 50%;
        animation: bounce 1.4s infinite ease-in-out both;
        
        &:nth-child(1) { animation-delay: -0.32s; }
        &:nth-child(2) { animation-delay: -0.16s; }
    }
    
    @keyframes bounce {
        0%, 80%, 100% { transform: scale(0); }
        40% { transform: scale(1); }
    }
`;

export const InputAreaWrapper = styled.div`
    flex-shrink: 0;
    margin: 20px 20px;
    padding: 10px 25px;
    background: #FFFFFF;
    border-radius: 42px;

    border: 2px solid transparent;
    background-clip: padding-box, border-box;
    background-origin: padding-box, border-box;
    background-image: linear-gradient(to right, #fff, #fff), linear-gradient(to right, red, #578aef);
`;

export const InputWrapper = styled.div`
    display: flex;
    gap: 12px;
    align-items: center;
`;

export const TextArea = styled.textarea`
    flex: 1 1 auto;
    font-size: 16px;
    line-height: 1.5;
    border: none;
    outline: none;
    resize: none;
    min-height: 60px;
    max-height: 200px;
    background: transparent;
    transition: border-color 0.3s;
`;

export const HistoryModalWrapper = styled.div`
    padding: 10px 0px;
`;

export const HistoryListWrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

export const HistoryItemWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    cursor: pointer;
    transition: background 0.2s;
    
    &:hover {
        background: rgba(0, 0, 0, 0.05);
    }
`;

export const HistoryItemContent = styled.div`
    flex: 1 1 auto;
    min-width: 0;
`;

export const HistoryItemTitle = styled.div`
    font-size: 14px;
    font-weight: 500;
    color: #333;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const HistoryItemTime = styled.div`
    font-size: 12px;
    color: #999;
    margin-top: 4px;
`;

export const HistoryItemActions = styled.div`
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    margin-left: 12px;

    &:hover {
        background: rgba(0, 0, 0, 0.1);
    }
`;
